import { render } from "./MobileAppView.vue?vue&type=template&id=e81bfe5a&scoped=true"
import script from "./MobileAppView.vue?vue&type=script&lang=js"
export * from "./MobileAppView.vue?vue&type=script&lang=js"

import "./MobileAppView.vue?vue&type=style&index=0&id=e81bfe5a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e81bfe5a"]])

export default __exports__